// 常量配置文件
var Appconstance = {
  // 接口返回码
  messagesInfo: {
    // 代码错误系统繁忙
    CODE_ERROR: "999999",
    // 自定义异常信息
    CUSTOM_ERROR: "700000",
    // 成功
    CODE_SUCCESS: "200",
    // 登录超时
    CODE_LOGIN_OVERTIME: "700012",
    // token失效
    CODE_LOGIN_OVERDUE: "700006"
  },
  //键盘按键
  KEY_CODE: {
    TOP: 38,
    BOTTOM: 40,
    ENTER: 13,
    F4: 115,
    F6: 117,
    F7: 118,
    F8: 119,
    F9: 120
  },

  //请求参数
  REQUEST_TYPE: {
    POST: "Post",
    /*
        this.Appconstance.REQUEST_TYPE.POST
        this.Appconstance.REQUEST_TYPE.GET
        */
    GET: "Get"
  },

  //打印状态
  PRITING_TYPE: {
    IS_SALES: 1, //销售打印
    IS_SALES_RETURN: 2, //退货打印
    OVERTYPE_RECEIPTS: 1,
    OVERTYPE_RECEIPTS_TEXT: "(重打小票)",
    UNCOLLECTED_PRINTING: 2
    // UNCOLLECTED_PRINTING_TEXT: "(未收款打印)"
  },

  // 首營状态 1、是  0、否
  TYPEAPPLY_STATUS_YES: 1,
  TYPEAPPLY_STATUS_NO: 0,

  // 非特管药
  NOT_SPECIAL_TUBE_MEDICINE: 1,

  // 零售管理
  retailManage: {
    //前台收银
    Cashier: {
      //是否可打折 1 是 0 否
      ISDISCOUNT_YES: 1,
      ISDISCOUNT_YES_TEXT: "是",
      ISDISCOUNT_NO_TEXT: "否",
      //处方药
      IS_PRESCRIPTION_MEDICINE: "处方药",
      IS_CHINA_MEDICINE: "中药饮片"
    }
  },

  //文件导出状态1:进行中，2:已完成
  FILE_EXPORT_ING: 1,
  FILE_EXPORT_ING_TEXT: "进行中",
  FILE_EXPORT_DOWN: 2,
  FILE_EXPORT_DOWN_TEXT: "已完成",
  FILE_EXPORT_FAILED: 3,
  FILE_EXPORT_FAILED_TEXT: "失败",

  //effectiveType效期类型（1=正常， 2=二级预警（效期在2-6月之内），3=一级预警（效期在2月之内），4=已过期）
  EFFECTIVE_TYPE_TWO_LEVEL: 2,
  EFFECTIVE_TYPE_ONE_LEVEL: 3,
  EFFECTIVE_TYPE_OVERDUE: 4,
  EFFECTIVE_TYPE_OVERDUE_TEXT: "已过期",

  //验收状态 1=收货待验收，2=待审批，3=已拒收
  RECEIVE_STATUS_FOR_ACCEPTANCE: 1,
  RECEIVE_STATUS_FOR_APPROVAL: 2,
  RECEIVE_STATUS_FOR_REJECT: 3,
  RECEIVE_STATUS_FOR_ACCEPTANCE_TEXT: "收货待验收",
  RECEIVE_STATUS_FOR_APPROVAL_TEXT: "待审批",
  RECEIVE_STATUS_FOR_REJECT_TEXT: "已拒收",

  //收货状态 0:草稿,1:待验收,2:已完成,3:已作废
  AS_RECEIVED_CONDITION_RECEIVING: 0,
  AS_RECEIVED_CONDITION_RECEIVING_TEXT: "待收货",
  AS_RECEIVED_CONDITION_FOR: 1,
  AS_RECEIVED_CONDITION_FOR_TEXT: "待验收",
  AS_RECEIVED_CONDITION_STOCK: 2,
  AS_RECEIVED_CONDITION_STOCK_TEXT: "已完成",
  // AS_RECEIVED_CONDITION_VOID: 3,
  // AS_RECEIVED_CONDITION_VOID_TEXT: '已作废',

  //门店状态 1=草稿，2=待审批，3=审批通过，9=已作废，0=审批不通过
  STORE_STATUS_APPROVAL_NOPASSED: 0,
  STORE_STATUS_DRAFT: 1,
  STORE_STATUS_APPROVAL: 2,
  STORE_STATUS_APPROVE: 3,
  STORE_STATUS_VOID: 9,
  STORE_STATUS_APPROVAL_NOPASSED_TEXT: "审批不通过",
  STORE_STATUS_DRAFT_TEXT: "草稿",
  STORE_STATUS_APPROVAL_TEXT: "待审批",
  STORE_STATUS_APPROVE_TEXT: "审批通过",
  STORE_STATUS_VOID_TEXT: "已作废",

  //总部状态
  ERP_STATUS_APPROVAL_NOPASSED: 0,
  ERP_STATUS_APPROVAL: 1,
  ERP_STATUS_APPROVE: 2,
  ERP_STATUS_APPROVAL_TEXT: "待审批",
  ERP_STATUS_APPROVE_TEXT: "审批通过",
  ERP_STATUS_APPROVAL_NOPASSED_TEXT: "审批不通过",

  //养护状态(1=待养护，2=审批中，3=审批通过)
  CONSERVATION_WAIT_STATUS: 1,
  CONSERVATION_WAIT_STATUS_TEXT: "待养护",
  CONSERVATION_APPROVAL_STATUS: 2,
  CONSERVATION_APPROVAL_STATUS_TEXT: "审批中",
  CONSERVATION_APPROVE_STATUS: 3,
  CONSERVATION_APPROVE_STATUS_TEXT: "审批通过",
  //养护类型（1=重点养护，2=一般养护）
  CONSERVATION_TYPE_ONE: 1,
  CONSERVATION_TYPE_ONE_TEXT: "重点养护",
  CONSERVATION_TYPE_TWO: 2,
  CONSERVATION_TYPE_TWO_TEXT: "一般养护",
  //待养护商品 来源类型(1=首次进场,2=商品基础信息,3=近效期品种,4=拆零库存,5=有可疑记录)
  CONSERVATION_ORIGIN_TYPE_ONE: 1,
  CONSERVATION_ORIGIN_TYPE_ONE_TEXT: "首次进场",
  CONSERVATION_ORIGIN_TYPE_TOW: 2,
  CONSERVATION_ORIGIN_TYPE_TOW_TEXT: "商品基础信息",
  CONSERVATION_ORIGIN_TYPE_THREE: 3,
  CONSERVATION_ORIGIN_TYPE_THREE_TEXT: "近效期品种",
  CONSERVATION_ORIGIN_TYPE_FOUR: 4,
  CONSERVATION_ORIGIN_TYPE_FOUR_TEXT: "拆零库存",
  CONSERVATION_ORIGIN_TYPE_FIVE: 5,
  CONSERVATION_ORIGIN_TYPE_FIVE_TEXT: "有可疑记录",

  //审批结果
  AUDIT_TYPE_DRAFT: "草稿",
  AUDIT_REFUSE: 0,
  AUDIT_APPROVE: 1,

  AUDIT_REFUSE_TEXT: "审核不通过",
  AUDIT_APPROVE_TEXT: "审核通过",

  // 收货状态 1、部分收货   2、未收货
  RECEIVE_STATUS_PORTION: 1,
  RECEIVE_STATUS_NOT: 2,
  RECEIVE_STATUS_PORTION_TEXT: "部分收货",
  RECEIVE_STATUS_NOT_TEXT: "未收货",

  // 验收状态
  ACCEPTANCE_STATUS_FOR: 1,
  ACCEPTANCE_STATUS_FOR_TEXT: "待验收",
  ACCEPTANCE_STATUS_DOWN: 2,
  ACCEPTANCE_STATUS_DOWN_TEXT: "已完成",

  // 禁用状态 1、是
  BANNED_USE_YES: 1,

  //禁销状态 1、是
  BANNED_SALES_YES: 1,

  // 禁入状态 1、是
  BANNED_ENTER_YES: 1,

  // 资格是否过期  1、过期
  ALREADY_OVERDUE: 1,

  // 拒收状态   1、待审核  2、审核通过
  REJECTION_APPROVA_WAIT_AUDIT: 1,
  REJECTION_APPROVA_SUCCESS: 2,

  REJECTION_APPROVA_WAIT_AUDIT_TEXT: "待审核",
  REJECTION_APPROVA_SUCCESS_TEXT: "审核通过",

  // 角色姓名
  roleName: {
    // 采购员
    BUYER: "采购员"
  },

  //前台收银商品类别  1 中药饮片 2 中西成药
  PRODUCT_TYPE_ONE: 1,
  PRODUCT_TYPE_ONE_TEXT: "中药饮片",
  PRODUCT_TYPE_TWO: 2,
  PRODUCT_TYPE_TWO_TEXT: "中西成药",

  /**
   *菜单业务跳转类型 请货申请单1 配送退货申请单2 装斗申请单3 清斗申请单4  商品拆零申请单5 零售退货申请单6 配送拒收单7 零售处方申请单8 质量复查单9 报损单14 销毁单15
   *
   */
  MENU_PURCHASE_PLAN: 1,
  MENU_PURCHASE_BACK: 2,
  MENU_INSTALL_BUCKET: 3,
  MENU_CLEAR_BUCKET: 4,
  MENU_PRODUCT_OPEN: 5,
  MENU_RETAIL_BACK: 6,
  MENU_PURCHASE_REJECTION: 7,
  MENU_RETAIL_RECIPE_APPLY: 8,
  MENU_QUALITY_REVIEW: 9,
  MENU_REJECT_REPORTED: 14,
  MENU_REJECT_DESTROY: 15,
  MENU_TRANSFER_APPROVAL: 16,

  /**
   *报损报溢类型(1报损,2报溢,3盘点报损,4盘点报溢)
   *
   */
  //"报损"
  REPORTEDLOSS:1,
  //"报溢"
  REPORTEDOVERFLOW:2,
  //"盘点报损"
  INVENTORYLOSS:3,
  //"盘点报溢"
  INVENTORYOVERFLOW:4
};
export default Appconstance;



// WEBPACK FOOTER //
// ./src/config/Appconstance.js